/**
 * Watches for Framer SPA navigation by detecting when elements matching
 * `watchSelectors` are added to the DOM, then re-runs `callback` so any
 * DOM logic is applied after each page transition without a full reload.
 */
export const observeFramerNavigation = (
  callback: () => void,
  watchSelectors: string
): MutationObserver => {
  const observer = new MutationObserver((mutations) => {
    const hasRelevantAdditions = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof HTMLElement)) return false;
        return node.matches(watchSelectors) || node.querySelector(watchSelectors) !== null;
      })
    );

    if (hasRelevantAdditions) callback();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  return observer;
};
